import '../../scss/components/_loader.scss';

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener('keydown', event => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const button= event.submitter ?? event.target.querySelector('button');

    button.innerHTML += '<div class="lds-default small"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
    button.disabled = true;
  });

  //JOB form
  let jobForm = document.getElementById('job-form');
  let successMessage = document.querySelector('.message.success');
  let errorMessages = document.querySelectorAll('.error-message')

  if (jobForm) {
    if (successMessage || errorMessages.length > 0) {
      window.scrollTo({
          top: jobForm.offsetTop - 120,
          behavior: 'smooth'
      });
    }
  }
});
